export default "__VITE_ASSET__Df1NFYGZ__"